export const BasePaths = {
  MAIN: "/app",
  SUPPLIERS: "/app/suppliers",
  ADMIN: "/admin",
  PERFORMANCE: "/app/performance-management",
  ASSET: "/app/asset",
};
export const PublicPaths = {
  HOME: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-Password",
  RESET_PASSWORD: "/reset-Password/:id",
  NEW_PASSWORD: "/new-password",
};

export const PrivatePaths = {
  DASHBOARD: "/app/dashboard",
  CATEGORY: "/app/category",
  POSTS: "/app/posts",
  ADMIN: "/app/admin",
  USERS: "/app/users",
};
